<template>

    <!-- SIDEBAR PANEL -->
    <div class="sidebar-panel" :class="{ open: panelOpen }" @click="panelDown($event)">

        <input type="checkbox" id="panel-toggle" name="panel-toggle" v-model="panelOpen" />

        <!-- PANEL CONTAINER -->
        <div class="panel-container">

            <!-- PANEL CONTENT -->
            <transition name="sbfade" mode="out-in" appear>
                <component
                    :is="activePanel.panel"
                    :slug="activePanel.slug"
                    :service="activePanel.service"
                    :premise="activePanel.premise"
                    v-if="activePanel"></component>
            </transition>
            <!-- END PANEL CONTENT -->

        </div>
        <!-- END PANEL CONTAINER -->

    </div>
    <!-- END SIDEBAR PANEL -->

</template>


<script>

    import PanelContentAbout from "./PanelContentAbout.vue";
    import PanelContentContact from "./PanelContentContact.vue";
    import PanelContentCoverages from "./PanelContentCoverages.vue";
    import PanelContentExposure from "./PanelContentExposure.vue";
    import PanelContentPowerSurge from "./PanelContentPowerSurge.vue";
    import PanelContentPrivacy from "./PanelContentPrivacy.vue";
    import PanelContentTerms from "./PanelContentTerms.vue";

    let vm = {};

    export default {

        name: 'sidebar-panel',

        components: {
            PanelContentAbout,
            PanelContentContact,
            PanelContentCoverages,
            PanelContentExposure,
            PanelContentPowerSurge,
            PanelContentPrivacy,
            PanelContentTerms
        },

        data() {
            return {
                domPanel: null
            }
        },

        computed: {

            activePanel() {
                return this.$dataStore.getters.getActivePanel;
            },

            panelOpen: {
                get: function() {
                    return vm.$dataStore.getters.getPanelState;
                },
                set: function(nVal) {
                    vm.$dataStore.dispatch('PANEL_OPEN', { val: nVal });
                    if (nVal === false) {
                        vm.$dataStore.dispatch('ACTIVE_PANEL', { val: null });

                        if (vm.$dataStore.getters.getPowerSurgeState) {
                            vm.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                            vm.$dataStore.dispatch('POWER_SURGE', { val: false });
                            vm.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                            vm.$eventBus.$emit('power-surge:end');
                        }

                        vm.$eventBus.$emit('points:state:reset');

                        // show points
                        vm.$eventBus.$emit('points:show');

                        // show instructions if not already shown...
                        vm.$eventBus.$emit('cta:show');
                    }
                }
            },

            powerSurge() {
                return this.$dataStore.state.interactive.powerSurge;
            }
        },

        created() {
            //console.info('%csidebar-panel::created', 'color:dodgerblue;');

            vm = this;

            // panel:toggle event handler
            vm.$eventBus.$on('panel:toggle', function(obj) {

                vm.$eventBus.$emit('share:close');

                // panel IS open & current active panel IS the requested panel (CLOSE PANEL, ACTIVE PANEL NULL)
                if (vm.$dataStore.state.interactive.panelOpen && (obj === vm.$dataStore.state.interactive.activePanel)) {

                    vm.closePanel();

                // panel IS NOT open, requested panel exists (OPEN PANEL, SET ACTIVE PANEL)
                } else if (!vm.$dataStore.state.interactive.panelOpen && obj) {

                    vm.$dataStore.dispatch('PANEL_OPEN', { val: true });
                    vm.$dataStore.dispatch('ACTIVE_PANEL', { val: obj });

                // panel IS open, requested panel exists (CLOSE PANEL, ACTIVE PANEL NULL, SET ACTIVE PANEL, OPEN PANEL)
                } else if (vm.$dataStore.state.interactive.panelOpen && obj) {

                    if (vm.$dataStore.state.interactive.activePanel.slug === obj.slug) {
                        vm.closePanel();
                    } else {
                        vm.closePanel();

                        setTimeout(function() {
                            vm.$dataStore.dispatch('PANEL_OPEN', { val: true });
                            vm.$dataStore.dispatch('ACTIVE_PANEL', { val: obj });
                        }, 600);
                    }

                }

                // show instructions if not already shown...
                vm.$eventBus.$emit('cta:show');

            });

            vm.$eventBus.$on('panel:close', vm.closePanel);


            let debouncedResize = _.debounce(vm.setPanel, 30);
            window.addEventListener('resize', debouncedResize, false);

        },

        mounted() {
            //console.info('%csidebar-panel::mounted', 'color:green;');

            vm = this;

            vm.setPanel();
        },

        methods: {

            clickOutside(evt) {
                evt.stopPropagation();
                document.removeEventListener('click', vm.clickOutside, false);

                if (this.$dataStore.getters.getPowerSurgeState) {
                    this.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                    this.$dataStore.dispatch('POWER_SURGE', { val: false });
                    this.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                    this.$eventBus.$emit('power-surge:end');
                }

                this.$dataStore.dispatch('PANEL_OPEN', { val: false });
                this.$dataStore.dispatch('ACTIVE_PANEL', { val: null });

                // show instructions if not already shown...
                vm.$eventBus.$emit('cta:show');

                vm.$eventBus.$emit('points:state:reset');

                // show points
                vm.$eventBus.$emit('points:show');
            },

            setPanel() {
                let _fHeight = $('footer').height();
                //console.log('_fHeight', _fHeight);

                $('.sidebar-panel').css({
                    height: 'calc(100% - ' + _fHeight + 'px)'
                });

            },

            panelDown(evt) {
                evt.stopPropagation();
            },

            /**
             * @method togglePanel
             * @description
             * @param {String} type
             * @param {String} slug
             * @param {Object} evt
             * @param {Boolean} service
             * @param {Boolean} premise
             */
            togglePanel(type, slug, evt, service, premise) {
                evt.stopPropagation();
                this.$eventBus.$emit('panel:toggle', { panel: type, slug: slug, service: service, premise: premise });
            },

            closePanel() {
                this.$dataStore.dispatch('PANEL_OPEN', { val: false });
                this.$dataStore.dispatch('ACTIVE_PANEL', { val: null });

                vm.$eventBus.$emit('points:state:reset');

                // show points
                vm.$eventBus.$emit('points:show');
            }

        },

        watch: {

            activePanel: function(nVal) {
                if (nVal) {
                    setTimeout(function() {
                        document.addEventListener('click', vm.clickOutside, false);
                    }, 1500);
                } else {
                    document.removeEventListener('click', vm.clickOutside, false);
                }
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .sidebar-panel {
        background-color: $white-100;
        width: 100%;
        max-width: 375px;
        height: calc(100% - 95px);
        box-shadow: 0 -2px 9px $black-25;
        position: fixed;
        top: 0;
        right: 70px;
        z-index: 5;
        transform: translateX(375px);
        transition: all 0.3s $easeInOutQuad;
        animation-duration: 0s;
        animation-delay: 0s;

        & input[type="checkbox"] {
            opacity: 0;
            visibility: hidden;
            position: absolute;
            top: 0;
            left: 0;
        }

        &.open {
            transform: translateX(0);
            transition: all 0.3s $easeInOutQuad;
        }

        & .panel-container {
            height: 100%;
            position: relative;
        }
    }

</style>

<style lang="scss">

    @import '../assets/styles/helpers/variables';

    .sidebar-panel {

        & .image {
            background-color: rgba(237,237,237, 1.0);
            text-align: center;
            display: block;

            & > img {
                max-width: 100%;
                height: auto;
                display: block;
            }
        }

        & .body {
            font-family: $font-univers-std;
            font-size: 0.875rem;
            font-weight: normal;
            line-height: 1.375;
            letter-spacing: 0;
            text-align: left;
            padding: 1.875rem;

            &.no-pad {
                padding: 0;
            }

            &.no-pad-lr {
                padding: 30px 0;
            }

            &.no-pad-tb {
                padding: 0 30px;
            }

            & h3 {
                font-family: $font-univers-bold;
                font-size: 1rem;
                font-weight: normal;
                line-height: 1;
                text-transform: none;
                margin: 0 0 12px 0;
            }

            & p {
                font-size: 0.875rem;
                line-height: 1.375;
            }

        }
    }


    .header {
        background-color: var(--color-primary);
        color: $white-100;
        line-height: 1;
        height: 50px;
        padding: 17px 16px 16px;
        overflow: hidden;
        display: flex;
        justify-content: center;

        & .icon {
            flex: 0 0 auto;
            position: relative;

            & label {
                width: 100%;
                height: 100%;
                margin: 0 0 0 0;

                &:hover {
                    cursor: pointer;

                    & .fa {
                        opacity: 0.8;
                        transition: all 0.3s $easeInOutQuad;
                    }
                }

                & .fa {
                    opacity: 1;
                    transition: all 0.3s $easeInOutQuad;
                }
            }
        }

        & .label {
            font-family: $font-univers-cond;
            font-size: 1rem;
            text-align: center;
            text-transform: uppercase;
            letter-spacing: 0.7px;
            white-space: nowrap;
            margin: 0 0 0 -17px;
            padding: 0 0 0 0;
            flex: 1 0 auto;
        }
    }

    .panel-content {
        height: calc(100% - 50px);

        &::after {
            content: '';
            background: linear-gradient(to bottom, $white-0 0%, $white-100 100%);
            width: 100%;
            height: 10px;
            display: none;
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 999;
            pointer-events: none;
        }
    }



    .sbfade-enter-active {
        transition: all 0.3s $easeInOutQuad 0s;
    }
    .sbfade-leave-active {
        transition: all 0.3s $easeInOutQuad 0s;
    }
    .sbfade-enter,
    .sbfade-leave-to {
        opacity: 1;
    }

</style>


// WEBPACK FOOTER //
// SidebarPanel.vue?70637668